var BlockView = require('views/block/base-block-view');
var ContentService = require('services/content-service');
var CourseSettingsService = require('services/course-settings-service');
var Menu = require('models/menu');
var MenuView = require('views/menu/menu-view');

let ContainerView = BlockView.extend({
  initialize: function() {
    this.model.set('cid', this.model.cid);
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    const blockRegionName = `${this.model.get('cid')}-blocks`;
    var menuKey = this.model.get('menu_key');
    if(menuKey)
    { 
      const menuSettings = CourseSettingsService.get('menu');
      const menu = new Menu(menuSettings);
      this.registerRegion(blockRegionName, '[data-region="' + blockRegionName + '"]');
      ContentService.applyContentAndLocale(menu, 'menu.' + menuKey)
      .then(model => {
        const menuView = new MenuView({
          className: menuKey,
          model: model,
          region: blockRegionName,
          subView: true
        });
        menuView.container.focus();
      });
    }
    else{
      return this.renderNestedBlocks(blockRegionName, this.model.get('blocks'));
    }
  },
  play: function() {
    this.readyToGo();
  }
});

export default ContainerView;
